import React from 'react'

const ProfileButtons = () => {
  return (
    <>
      <div className="shadow-sm p-4 rounded-4 me-4 bg-white bg-white bg-white">
        <div className="text-theme mb-3 text-center">
          <span className="me-3 fw-medium">
            <strong>51</strong> Buddies
          </span>
          <span className="me-3 fw-medium">
            <strong>45</strong> Followers
          </span>
          <span className="fw-medium">
            <strong>43</strong> Following
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <button>
            <img src="/images/add-buddies-button.svg" alt="" />{' '}
          </button>
          <button>
            <img src="/images/follow-button.svg" alt="" />{' '}
          </button>
          <button>
            <img src="/images/message-btn.svg" alt="" />{' '}
          </button>
        </div>
        <div className="d-flex justify-content-between">
          <button>
            <img src="/images/requested-button.svg" alt="" />{' '}
          </button>
          <button>
            <img src="/images/following.svg" alt="" />{' '}
          </button>
          <button>
            <img src="/images/message-btn.svg" alt="" />{' '}
          </button>
        </div>
        <div className="d-flex justify-content-between">
          <button>
            <img src="/images/buddies-active.svg" alt="" />{' '}
          </button>
          <button>
            <img src="/images/following.svg" alt="" />{' '}
          </button>
          <button>
            <img src="/images/message-btn.svg" alt="" />{' '}
          </button>
        </div>
        <div>
          <button
            className="p-0"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            <img src="/images/remove-buddies.svg" alt="" />{' '}
          </button>
          {/* <!-- <button className="p-0" data-bs-toggle="modal" data-bs-target="#exampleModal"><img src="images/unfollow.svg" alt=""/> </button>  --> */}
        </div>

        {/* <!-- Modal --> */}
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src="/images/remove-buddiesmodal-icon.svg" alt="" />
                <h4 className="py-4 text-dark">Remove buddy</h4>
                <p>
                  Are you sure you want to remove Firstname Last name from your
                  buddies?
                </p>
              </div>
              <div className="modal-footer justify-content-center border-0">
                <button type="button" data-bs-dismiss="modal">
                  <img src="/images/cancle-modal.svg" alt="" />
                </button>
                <button type="button">
                  <img src="/images/remove-modal.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProfileButtons
